import React, { useState } from 'react';
import './QuizPage.css'
import { PageProps } from '../../models/PageProps';
import StartSlide from '../../components/QuizSlides/StartSlide/StartSlide';
import QuestionSlide from '../../components/QuizSlides/QuestionSlide/QuestionSlide';
import EndSlide from '../../components/QuizSlides/EndSlide/EndSlide';
import { initialQuizData } from '../../data/QuizQuestionsData';
import { SlideAnswerData, Quiz, QuizResult } from '../../models/Quiz';
import { QuizHelper } from '../../util/QuizHelper';
import SubmissionSlide from '../../components/QuizSlides/SubmissionSlide/SubmissionSlide';
import HttpClient from '../../util/HttpClient';
import { SendQuizRequest } from '../../models/SendQuizRequest';


export enum GameStatus {
  Before = 'before',
  During = 'during',
  Submission = 'ubmission',
  After = 'after',
}

type QuizState =
  | { status: GameStatus.Before }
  | { status: GameStatus.During }
  | { status: GameStatus.Submission}
  | { status: GameStatus.After };

function QuizPage({ smallScreen }: PageProps) {

  const quizHelper: QuizHelper = new QuizHelper()
  const httpClient: HttpClient = new HttpClient()

  const [quizState, setQuizState] = useState<QuizState>({ status: GameStatus.Before }) 
  const [quizData, setQuizData] = useState<Quiz>(initialQuizData)
  const [showError, setShowError] = useState(false)
  const [currentQuestion, setCurrentQuestion] = useState<number>(0)

  const [quizResult, setQuizResult] = useState<QuizResult | null>(null) 

  const startQuiz = () => {
    setQuizState({ status: GameStatus.During })
  }

  const nextSlide = () => {
    
    // If no answer is select, show error
    if (quizData.quizSlides[currentQuestion].answers.find((it) => it.selected)) {
      
      let shouldEndQuiz = false

      // If it's the last question, determine is tiebreaker is necessary
      if (currentQuestion + 1 === quizData.quizSlides.length - 1) {

        let typesToFilterOut = quizHelper.answerTypesToFilterOut(quizData)

        console.log(typesToFilterOut)

        if (typesToFilterOut.length > 0 && typesToFilterOut.length < 4) {
          setQuizData(prevQuiz => ({
            ...prevQuiz,
            quizSlides: prevQuiz.quizSlides.map(slide => ({
              ...slide,
              answers: slide.answers.filter(
                answer => !typesToFilterOut.includes(answer.answerType)
              )
            }))
          }));
        } 

        if(typesToFilterOut.length === 0){
          shouldEndQuiz = true
        }
      }

      if (currentQuestion === quizData.quizSlides.length - 1) {
        shouldEndQuiz = true
      }

      if(shouldEndQuiz)
        endQuiz()
      else{
        setCurrentQuestion(currentQuestion + 1)
      }

    } else {
      setShowError(true)
    }
  }

  const endQuiz = () => {
      setQuizResult(quizHelper.getQuizResults(quizData))
      setQuizState({ status: GameStatus.Submission })
  }

  const submitQuiz = (name: string, email: string) => {

    httpClient.postSendQuizResultMessage({toName: name, toEmail: email, resultType: quizResult?.personalityType} as SendQuizRequest)

    setQuizState({ status: GameStatus.After })
  }


  const handleAnswerSelect = (
    questionId: number,
    answerId: number
  ): void => {
    setQuizData((prevData): Quiz => {

      setShowError(false)

      const updatedQuizSlides = prevData.quizSlides.map((slide) => {
        if (slide.questionId !== questionId) {
          return slide;
        }

        const updatedAnswers: [SlideAnswerData, SlideAnswerData, SlideAnswerData, SlideAnswerData] =
          slide.answers.map((answer) => ({
            ...answer,
            selected: answer.answerId === answerId,
          })) as [SlideAnswerData, SlideAnswerData, SlideAnswerData, SlideAnswerData];

        return {
          ...slide,
          answers: updatedAnswers,
        };
      });

      return {
        ...prevData,
        quizSlides: updatedQuizSlides,
      };
    });
  };

  return (
    <div className='quiz-page centered'>
      {quizState.status === GameStatus.Before && (
        <StartSlide startQuiz={startQuiz} />
      )}

      {quizState.status === GameStatus.During && (
        <QuestionSlide slideData={quizData.quizSlides[currentQuestion]} showError={showError} nextSlide={nextSlide} selectAnswer={handleAnswerSelect} />
      )}

      {quizState.status === GameStatus.Submission && (
        <SubmissionSlide submitQuiz={submitQuiz} />
      )}

      {quizState.status === GameStatus.After && (
        <EndSlide quizResults={quizResult} />
      )}
    </div>
  );
}

export default QuizPage;